import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { ModeratorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { UserImage } from 'assets/img';
import { PasswordActive, PasswordInactive } from 'assets/icons';

import PHONE_CODES from 'utils/phonecodes';

import { isValidPhoneNumber } from 'libphonenumber-js';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
  modules?: any[];
}

class CreateModerator extends React.Component<Props> {
  state = {
    activePassword: false,
    activePasswordConfirmation: false,
    modules: [],
    form: {
      name: '',
      lastname: '',
      phone: '',
      phone_code: PHONE_CODES[0].value,
      document: '',
      document_type_id: Constants.DOCUMENT_TYPES.V,
      email: '',
      password: '',
      password_confirmation: '',
      photo: '',
    },
    document_types: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await ModeratorService.admin.getDocumentTypes();
    this.setState(
      {
        modules: Globals.clone(this.props.modules),
        document_types: res.document_types || [],
      },
      () => {
        if (this.props.item) {
          let reconstructedPhone = this.props.item?.phone || '';
          const savedPhonecodeId = this.props.item?.phonecode_id;

          if (savedPhonecodeId && res.phonecodes?.length > 0) {
            const operadora = res.phonecodes.find((p: any) => p.id === savedPhonecodeId);
            if (operadora) {
              const prefix = operadora.name.replace(/^0/, '');
              if (!reconstructedPhone.startsWith(prefix)) {
                reconstructedPhone = prefix + reconstructedPhone;
              }
            }
          }

          const resolvedPhoneCode = this.props.item?.phone_code
            ? PHONE_CODES.find(
                (p: any) =>
                  p.value === this.props.item.phone_code ||
                  p.callingCode === this.props.item.phone_code,
              )?.value || PHONE_CODES[0].value
            : PHONE_CODES[0].value;

          this.setState({
            form: {
              ...this.state.form,
              name: this.props.item?.name || '',
              lastname: this.props.item?.lastname || '',
              document: this.props.item?.document || '',
              document_type_id: this.props.item?.document_type_id || Constants.DOCUMENT_TYPES.V,
              phone: reconstructedPhone,
              phone_code: resolvedPhoneCode,
              email: this.props.item?.email || '',
            },
            modules: Globals.clone(this.props.modules).map((i: any) => {
              if (this.props.item?.module_permissions) {
                const permission = this.props.item?.module_permissions.find(
                  (item: any) => item.module_id == i.id,
                );
                if (permission) {
                  i.read = permission.read == true;
                  i.write = permission.write == true;
                  i.delete = permission.delete == true;
                }
              }
              return i;
            }),
          });
        }
      },
    );
  };

  submit = async (e: any) => {
    e.preventDefault();

    const isEditing = this.props.item != null;

    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;

    if (!this.state.form.name) {
      Globals.showError('Por favor, ingrese el nombre');
      return;
    }

    if (!nameRegex.test(this.state.form.name)) {
      Globals.showError('El nombre solo puede contener letras y espacios');
      return;
    }

    if (!this.state.form.lastname) {
      Globals.showError('Por favor, ingrese el apellido');
      return;
    }

    if (!nameRegex.test(this.state.form.lastname)) {
      Globals.showError('El apellido solo puede contener letras y espacios');
      return;
    }

    if (!!this.state.form.password) {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/;
      if (!passwordRegex.test(this.state.form.password)) {
        Globals.showError(
          'La contraseña debe tener al menos una mayúscula, una minúscula, un número y un símbolo',
        );
        return;
      }

      if (this.state.form.password.length < 6) {
        Globals.showError('La contraseña debe tener al menos 6 caracteres');
        return;
      }
    } else if (!isEditing) {
      Globals.showError('Por favor, ingrese la contraseña');
      return;
    }

    if (
      this.state.form.password &&
      this.state.form.password != this.state.form.password_confirmation
    ) {
      Globals.showError('Las contraseñas no coinciden');
      return;
    }

    if (
      this.state.form.phone &&
      !isValidPhoneNumber(this.state.form.phone, this.state.form.phone_code as any)
    ) {
      Globals.showError('El número de teléfono no es válido para el país seleccionado');
      return;
    }

    if (!this.state.form.email) {
      Globals.showError('Por favor, ingrese el correo electrónico');
      return;
    }

    try {
      if (this.props.item != null) {
        await ModeratorService.admin.update({
          user_id: this.props.item?.id,
          ...this.state.form,
          hasFile: true,
          // @ts-ignore,
          photo: this.state.form.photo?.value || '',
          module_permissions: JSON.stringify(
            this.state.modules.map((i: any) => {
              return {
                module_id: i.id,
                read: i.read,
                write: i.write,
                delete: i.delete,
              };
            }),
          ),
        });
        Globals.showSuccess('Se ha modificado el moderador correctamente');
        this.props.onClose();
      } else {
        await ModeratorService.admin.create({
          ...this.state.form,
          hasFile: true,
          // @ts-ignore,
          photo: this.state.form.photo?.value || '',
          module_permissions: JSON.stringify(
            this.state.modules.map((i: any) => {
              return {
                module_id: i.id,
                read: i.read,
                write: i.write,
                delete: i.delete,
              };
            }),
          ),
        });
        Globals.showSuccess('Se ha creado el moderador correctamente');
        this.props.onClose();
      }
    } catch (err: any) {
      Globals.showError(err.friendlyMessage);
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  checkModule = (index: number, target: string) => {
    let modules: any = [...this.state.modules];
    if (target == 'active') {
      if (modules[index]['write'] && modules[index]['read'] && modules[index]['delete']) {
        modules[index]['read'] = false;
        modules[index]['write'] = false;
        modules[index]['delete'] = false;
      } else {
        modules[index]['read'] = true;
        modules[index]['write'] = true;
        modules[index]['delete'] = true;
      }
    } else {
      modules[index][target] = !modules[index][target];
    }
    this.setState({
      modules,
    });
  };

  render() {
    return (
      <div id='modal-create-moderators'>
        <form className='row' onSubmit={this.submit}>
          <div className='col-md-12'>
            <div className='container-inputs row'>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.name}
                  name='name'
                  label='Nombre'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.lastname}
                  name='lastname'
                  label='Apellido'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'>
                <p className='label'>C.I.</p>
                <div className='container-select'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    name='document_type_id'
                    onChange={this.change}
                    value={this.state.form.document_type_id}
                    options={this.state.document_types.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                  <Input
                    type='number'
                    color='white'
                    value={this.state.form.document}
                    name='document'
                    maxLength={9}
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <p className='label'>Teléfono</p>
                <div className='container-select'>
                  <Select
                    color='white'
                    placeholder='Código'
                    name='phone_code'
                    style={{ width: 115 }}
                    onChange={this.change}
                    value={this.state.form.phone_code}
                    options={PHONE_CODES}
                  />
                  <Input
                    type='number'
                    color='white'
                    maxLength={15}
                    value={this.state.form.phone}
                    name='phone'
                    onChange={this.change}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <Input
                  color='white'
                  value={this.state.form.email}
                  name='email'
                  label='Correo'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-6'></div>
              <div className='col-md-6'>
                <label>
                  {this.props.item != null ? 'Cambiar Contraseña (Opcional)' : 'Contraseña'}
                </label>
                <div className='input-password-wrapper'>
                  <Input
                    type={this.state.activePassword ? 'text' : 'password'}
                    color='white'
                    value={this.state.form.password}
                    name='password'
                    onChange={this.change}
                  />
                  <div
                    className='password-view'
                    onClick={() =>
                      this.setState({
                        activePassword: !this.state.activePassword,
                      })
                    }
                  >
                    <img src={this.state.activePassword ? PasswordActive : PasswordInactive} />
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <label>Repetir contraseña</label>
                <div className='input-password-wrapper'>
                  <Input
                    type={this.state.activePasswordConfirmation ? 'text' : 'password'}
                    color='white'
                    value={this.state.form.password_confirmation}
                    name='password_confirmation'
                    onChange={this.change}
                  />
                  <div
                    className='password-view'
                    onClick={() =>
                      this.setState({
                        activePasswordConfirmation: !this.state.activePasswordConfirmation,
                      })
                    }
                  >
                    <img
                      src={
                        this.state.activePasswordConfirmation ? PasswordActive : PasswordInactive
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='container-cyan'>
              <h3>Acceso a:</h3>
              <table>
                <thead>
                  <tr>
                    <td style={{ paddingLeft: '10px' }}></td>
                    <td className='text-center'>Ver</td>
                    <td className='text-center'>Escribir</td>
                    <td className='text-center' style={{ paddingRight: '10px' }}>
                      Eliminar
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {(this.state.modules || []).map((item: any, index: number) => {
                    return (
                      <tr>
                        <td style={{ paddingLeft: '10px' }}>
                          <div className='td-check'>
                            <CheckboxTable
                              size='small'
                              active={item.read && item.write && item.delete}
                              onClick={() => this.checkModule(index, 'active')}
                            />
                            {item.name}
                          </div>
                        </td>
                        <td className='td-center'>
                          <CheckboxTable
                            size='small'
                            active={item.read}
                            onClick={() => this.checkModule(index, 'read')}
                          />
                        </td>
                        <td className='td-center'>
                          <CheckboxTable
                            size='small'
                            active={item.write}
                            onClick={() => this.checkModule(index, 'write')}
                          />
                        </td>
                        <td className='td-center' style={{ paddingRight: '10px' }}>
                          <CheckboxTable
                            size='small'
                            active={item.delete}
                            onClick={() => this.checkModule(index, 'delete')}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className='col-md-12 text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreateModerator;
